import * as React from 'react';
import { cn } from '@/lib/utils';

/** Стеклянная панель поверх цветного фона. */
export function Card({ className, ...props }: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={cn('panel text-card-foreground', className)}
      {...props}
    />
  );
}
